import React,{Component} from  'react';
import moment from 'moment';
import PropTypes from 'prop-types';
import {EmptyDay} from './Day';

const _MS_PER_DAY = 1000 * 60 * 60 * 24;

class CalendarLine extends Component{

    shouldComponentUpdate(nextProps, nextState, nextContext) {
        const plansDifferent = JSON.stringify(this.props.plans) !== JSON.stringify(nextProps.plans);
        const eventsDifferent = JSON.stringify(this.props.events) !== JSON.stringify(nextProps.events);
        const daysDifferent = this.props.days[0] !== nextProps.days[0] ||
            this.props.days.length !== nextProps.days.length;
        const wasHighLighted = !!(this.props.person.id === this.props.highLightPersonId);
        const isHighLighted = !!(nextProps.person.id === nextProps.highLightPersonId);

        return plansDifferent || daysDifferent || (wasHighLighted !== isHighLighted) || eventsDifferent;
    }

    render(){
        const props = this.props;
        const person = props.person;
        const highLightId = props.highLightPersonId;
        const granularity = props.granularity;
        const days = props.days;
        const dayWidth = props.dayWidth;
        const plans = props.plans;
        const eventColor = props.eventColor;
        const events = props.events.filter(x => x.invitations.find(y => y.status === 1 && y.personId === person.id) != null);
        events.forEach(e => {
            plans.push({startTime: e.startTime, endTime: e.endTime, colorCode: eventColor});
        });

        const toggleDeleteBox = (plan) => {
            this.props.onToggleDeleteBox(plan);
        };

        const createDeleteBox = (plan) => {
            const planType = plan.colorCode.name.toLowerCase();

            // de skal ikke kunne slette godkendt ferie eller events
            if(planType=== "godkendt ferie" || planType=== "event"  || !plan.showDelete || plan === undefined) {
                return null;
            } 

            
            return  (<div className="delete-box">
                <div className="background"></div>
                <div className="text-wrapper">
                    Vil du slette {plan.person.name.trim().split(/\s+/)[0]}'s plan "{plan.colorCode.name}"?
                </div>
                <button className="delete-button" onClick={() =>  this.props.onDeletePlannedItem(plan.id)}>Slet</button>
                    <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" className="bi bi-x-circle-fill close" viewBox="0 0 16 16" onClick={() => toggleDeleteBox(plan)}>
                        <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM5.354 4.646a.5.5 0 1 0-.708.708L7.293 8l-2.647 2.646a.5.5 0 0 0 .708.708L8 8.707l2.646 2.647a.5.5 0 0 0 .708-.708L8.707 8l2.647-2.646a.5.5 0 0 0-.708-.708L8 7.293 5.354 4.646z" />
                    </svg>
            </div>) ;
        }
        
        const hourComponents = (() => {
            const rendered = new Set();
            const comps = [];
            const hourPlans = plans.filter(p => moment(p.endTime).diff(p.startTime, 'hour') > 0);
            for (let i = 0; i < hourPlans.length; i++) {
                const p = hourPlans[i];
                if (rendered.has(p.id)) continue;

                // skip events for split logic but still render them
                if (p.colorCode === props.eventColor) {
                    const startTime = moment(p.startTime).diff(props.startTime, 'hour') * dayWidth;
                    const duration = moment(p.endTime).diff(p.startTime, 'hour');
                    if (duration > 0) {
                        comps.push(<div key={p.id}><div onClick={() => toggleDeleteBox(p)} className={`plan event day`} style={{left: `${startTime}%`, backgroundColor: p.colorCode.hexColor, width: `${dayWidth*duration}%`}}/></div>);
                    }
                    rendered.add(p.id);
                    continue;
                }

                // find any partner that overlaps in time (partial or full) and is the opposite recycle state
                const partner = hourPlans.find(o => !rendered.has(o.id) && o.id !== p.id && ((o.colorCode.systemName === 'recycle' && p.colorCode.systemName !== 'recycle') || (p.colorCode.systemName === 'recycle' && o.colorCode.systemName !== 'recycle')) && o.colorCode !== props.eventColor && p.colorCode !== props.eventColor && moment(o.startTime).isBefore(p.endTime) && moment(o.endTime).isAfter(p.startTime));
                if (partner) {
                    // When overlapping, render recycle as a single full-range bottom-half,
                    // and render the other plan as top-half only over its own span.
                    const otherPlan = p.colorCode.systemName === 'recycle' ? partner : p;
                    const recyclePlan = p.colorCode.systemName === 'recycle' ? p : partner;

                    // recycle full-range
                    const recStartTime = moment(recyclePlan.startTime).diff(props.startTime, 'hour') * dayWidth;
                    const recDuration = moment(recyclePlan.endTime).diff(recyclePlan.startTime, 'hour');
                    if (recDuration > 0) {
                        comps.push(
                            <div key={`${recyclePlan.id}-full`}>
                                <div onClick={() => toggleDeleteBox(recyclePlan)} className={`plan recycle day`} style={{left: `${recStartTime}%`, backgroundColor: recyclePlan.colorCode.hexColor, width: `${dayWidth*recDuration}%`, height: '50%', position: 'absolute', bottom: 0}}/>
                                {createDeleteBox(recyclePlan)}
                            </div>
                        );
                    }

                    // other plan only top-half over its own span
                    const otherStartTime = moment(otherPlan.startTime).diff(props.startTime, 'hour') * dayWidth;
                    const otherDuration = moment(otherPlan.endTime).diff(otherPlan.startTime, 'hour');
                    if (otherDuration > 0) {
                        comps.push(
                            <div key={`${otherPlan.id}-top`}>
                                <div onClick={() => toggleDeleteBox(otherPlan)} className={`plan day`} style={{left: `${otherStartTime}%`, backgroundColor: otherPlan.colorCode.hexColor, width: `${dayWidth*otherDuration}%`, height: '50%', position: 'absolute', top: 0}}/>
                                {createDeleteBox(otherPlan)}
                            </div>
                        );
                    }

                    rendered.add(p.id);
                    rendered.add(partner.id);
                    continue;
                }

                // no partner, render normally
                const startTime = moment(p.startTime).diff(props.startTime, 'hour') * dayWidth;
                const duration = moment(p.endTime).diff(p.startTime, 'hour');
                if (duration > 0) {
                    const isEvent = p.colorCode === props.eventColor;
                    comps.push(<div key={p.id}><div onClick={() => toggleDeleteBox(p)} className={`plan ${isEvent ? 'event' : ''} ${p.colorCode.systemName === 'recycle' ? 'recycle' : ''} day`} style={{left: `${startTime}%`, backgroundColor: p.colorCode.hexColor, width: `${dayWidth*duration}%`}}/>{isEvent ? null : createDeleteBox(p)}</div>);
                }
                rendered.add(p.id);
            }
            return comps;
        })();

        const dayComponents = () => {
            const start = new Date(props.startTime);
            // Group plans by day (startTime)
            const plansByDay = {};
            plans.forEach((p) => {
                let planStart = new Date(new Date(p.startTime));
                const dayKey = planStart.toDateString();
                if (!plansByDay[dayKey]) plansByDay[dayKey] = [];
                plansByDay[dayKey].push(p);
            });

            let idx = 0;
            return Object.entries(plansByDay).map(([dayKey, dayPlans]) => {
                // Check for event color
                const eventPlan = dayPlans.find(p => p.colorCode === props.eventColor);
                if (eventPlan) {
                    // Render event as usual
                    let planStart = new Date(new Date(eventPlan.startTime));
                    let planEnd = new Date(eventPlan.endTime);
                    const startTime = Math.ceil(((planStart - start) / _MS_PER_DAY) - 1) * dayWidth;
                    const duration = Math.ceil((planEnd - planStart) / _MS_PER_DAY);
                    <div key={idx++}>
                        <div onClick={() => toggleDeleteBox(eventPlan)} className={`plan event day`} style={{left: `${startTime}%`, backgroundColor: eventPlan.colorCode.hexColor, width: `${dayWidth*duration}%`}}/>
                        {null}
                    </div>;
                }

                // Find recycle and another (non-event) color code
                const recyclePlan = dayPlans.find(p => p.colorCode.systemName === 'recycle');
                const otherPlan = dayPlans.find(p => p.colorCode.systemName !== 'recycle');

                if (recyclePlan && otherPlan) {
                    return this.renderSplitPlanBar(
                        otherPlan,
                        recyclePlan,
                        start,
                        dayWidth,
                        toggleDeleteBox,
                        createDeleteBox,
                        idx++
                    );
                }

                // Default: render all plans for this day as usual
                return dayPlans.map((p, i) => {
                    let planStart = new Date(new Date(p.startTime));
                    const isSick = p.colorCode.systemName === 'sick';
                    let planEnd = new Date(p.endTime);
                    if(isSick){
                        const fromPlan = moment(p.endTime);
                        const startM = moment(p.startTime);
                        const now = moment();
                        const nowadd3days = moment().add(1, 'days');
                        planEnd = fromPlan < nowadd3days ? fromPlan : nowadd3days;
                        planStart = startM > now ? startM : now;
                    }
                    const startTime = Math.ceil(((planStart - start) / _MS_PER_DAY) - 1) * dayWidth;
                    const duration = Math.ceil((planEnd - planStart) / _MS_PER_DAY);
                    const isEvent = p.colorCode === props.eventColor;
                    if(duration > 0){
                        return <div key={i}>
                            <div onClick={() => toggleDeleteBox(p)} className={`plan ${isEvent ? 'event' : ''} ${p.colorCode.systemName === 'recycle' ? 'recycle' : ''} day`} style={{left: `${startTime}%`, backgroundColor: p.colorCode.hexColor, width: `${dayWidth*duration}%`}}/>
                            {isEvent ? null : createDeleteBox(p)}
                        </div>
                    }
                    return null;
                });
            });
        };

        const grid = days.map((d,i) => {
            return <EmptyDay key={i} size={dayWidth} highlight={person.id === highLightId}/>;
        });


        return (
            <div className="row" onClick={props.onClick || null}>
                <div className={`name${person.leader ? ' leader' : ''}`}>{person.name}</div>
                <div className='plans'>
                    {granularity === 'hour' ? hourComponents : dayComponents()}
                </div>
                <div className='cell-grid'>
                    {grid}
                </div>
            </div>
        );
    };

    // Helper to render a split color bar for recycle + other
    renderSplitPlanBar = (otherPlan, recyclePlan, start, dayWidth, toggleDeleteBox, createDeleteBox, idx, mode = 'day', overlapStart = null, overlapEnd = null) => {
        let startTime, duration;
        if (mode === 'hour') {
            const s = overlapStart ? moment(overlapStart) : moment(otherPlan.startTime);
            const e = overlapEnd ? moment(overlapEnd) : moment(otherPlan.endTime);
            startTime = s.diff(start, 'hour') * dayWidth;
            duration = e.diff(s, 'hour');
        } else {
            // day mode
            let planStart = overlapStart ? new Date(overlapStart) : new Date(new Date(otherPlan.startTime));
            let planEnd = overlapEnd ? new Date(overlapEnd) : new Date(otherPlan.endTime);
            startTime = Math.ceil(((planStart - start) / _MS_PER_DAY) - 1) * dayWidth;
            duration = Math.ceil((planEnd - planStart) / _MS_PER_DAY);
        }
        const splitBg = `linear-gradient(to bottom, ${otherPlan.colorCode.hexColor} 0%, ${otherPlan.colorCode.hexColor} 50%, ${recyclePlan.colorCode.hexColor} 50%, ${recyclePlan.colorCode.hexColor} 100%)`;
        return (
            <div key={idx}>
                <div
                    onClick={() => { toggleDeleteBox(otherPlan); toggleDeleteBox(recyclePlan); }}
                    className={`plan day split`}
                    style={{
                        left: `${startTime}%`,
                        width: `${dayWidth*duration}%`,
                        background: splitBg,
                        position: 'absolute'
                    }}
                />
                {createDeleteBox(otherPlan)}
                {createDeleteBox(recyclePlan)}
            </div>
        );
    }
}

CalendarLine.propTypes = {
    granularity: PropTypes.string.isRequired,
    highLightPersonId: PropTypes.string,
    onClick: PropTypes.func,
    startTime: PropTypes.any.isRequired,
    totalTime: PropTypes.number.isRequired
};

export default CalendarLine;